import { ContentRegistrationFormPayload } from '@/common/types';
import { saveAs } from 'file-saver';
import {
  getFileNameForJournalArticleRecord,
} from '@content-registration/utils/journalArticles';
import { ContentRegistrationType } from '@/common/types';

export const readUploadedFileAsText = (
  inputFile: File
): Promise<string | ArrayBuffer | null> => {
  const temporaryFileReader: FileReader = new FileReader();

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort();
      reject(new DOMException('Problem parsing input file.'));
    };

    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result);
    };
    temporaryFileReader.readAsText(inputFile);
  });
};

const getFileNameForRecord = (
  record: ContentRegistrationFormPayload
): string => {
  switch (record.recordType) {
    case ContentRegistrationType.JournalArticle:
      return getFileNameForJournalArticleRecord(record);
    default:
      return `${record.recordId}.json`;
  }
};

export const downloadRecordFile = (
  record: ContentRegistrationFormPayload
): void => {
  const blob = new Blob([JSON.stringify(record)], {
    type: 'text/plain;charset=utf-8',
  });
  saveAs(blob, getFileNameForRecord(record));
};

